module.exports = __webpack_public_path__ + "img/our-story-photo.b136c5cb.jpg";